/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .factory("StoreAdminSrv", ($rootScope, $resource) =>
    $resource(
      $rootScope.globalConfig.apipath + "/store/:id",
      { id: "@id" },
      {
        update: {
          method: "PUT",
        },
        updateFixedSnapshot: {
          url: $rootScope.globalConfig.apipath + "/store/:id/fixedsnapshot",
          method: "PUT",
        },
        generateReport: {
          url: $rootScope.globalConfig.apipath + "/store/:id/sbiz365report",
          method: "POST",
        },
      }
    )
  )
  .factory("StoreAccessSrv", ($rootScope, $resource) =>
    $resource(
      `${$rootScope.globalConfig.apipath}/store/:storeId/access/:item/:id`,
      {
        storeId: "@storeId",
        item: "@item",
        id: "@id",
      },
      {
        get: {
          method: "GET",
        },

        add: {
          method: "POST",
          isArray: true,
        },

        setPermission: {
          method: "PUT",
        },

        remove: {
          method: "DELETE",
        },
      }
    )
  )
